module.exports = __webpack_public_path__ + "static/media/poorwill10.fe7969e5.JPG";